/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core'
import { SecuritiesSelectedComponent } from './securities-selected.component'

/**
 * This is used in tests that depend on SecuritiesSelectedComponent
 */
@Component({
  selector: 'hs-securities-selected',
  template: '<ng-template [ngTemplateOutlet]="content"></ng-template>',
})
export class MockSecuritiesSelectedComponent
  implements Partial<SecuritiesSelectedComponent>
{
  @Input() content: TemplateRef<any> | null = null
  @Output() securitySelectionChange = new EventEmitter<number[]>()
}
